export const InputSizeClasses = {
  INPUT_SIZE_SM: ['wf-h-6', 'wf-px-1', 'wf-text-xs'],
  INPUT_SIZE_MD: ['wf-h-10', 'wf-px-2', 'wf-text-sm'],
  INPUT_SIZE_LG: ['wf-h-12', 'wf-px-4', 'wf-text-base'],
  INPUT_SIZE_XL: ['wf-h-16', 'wf-px-6', 'wf-text-lg'],
}